module.exports = __webpack_public_path__ + "static/img/user-avatar-default-blue.1c4fcd10.png";